import React, { useState } from 'react';
import './AdminLayout.css';

const AdminLayout = ({ featureGroupId, featureGroupName, featureGroupDescription, userRole, onUpdate, children, activePanel, onPanelChange }) => {
  const [localActivePanel, setLocalActivePanel] = useState(activePanel || 'info');

  const handlePanelChange = (panel) => {
    setLocalActivePanel(panel);
    if (onPanelChange) {
      onPanelChange(panel);
    }
  };

  const currentPanel = activePanel !== undefined ? activePanel : localActivePanel;

  const panels = [
    { id: 'info', label: 'Feature Map Info', icon: 'fa-info-circle' },
    { id: 'users', label: 'Users', icon: 'fa-users' },
    { id: 'companies', label: 'Companies', icon: 'fa-building' },
    { id: 'dimensions', label: 'Dimensions', icon: 'fa-tags' },
    { id: 'prompts', label: 'Prompts', icon: 'fa-comment-dots' },
    { id: 'product-details', label: 'Product Details', icon: 'fa-file-alt' },
    { id: 'data', label: 'Data Management', icon: 'fa-database' }
  ];

  // Find the active panel child
  let activeChild = null;
  React.Children.forEach(children, child => {
    if (child && child.props && child.props.panelId === currentPanel) {
      activeChild = child;
    }
  });

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>Admin</h2>
        </div>
        <nav className="admin-nav">
          {panels.map(panel => (
            <button
              key={panel.id}
              className={`admin-nav-item ${currentPanel === panel.id ? 'active' : ''}`}
              onClick={() => handlePanelChange(panel.id)}
            >
              <i className={`fas ${panel.icon}`}></i>
              <span>{panel.label}</span>
            </button>
          ))}
        </nav>
      </div>
      <div className="admin-content-area">
        <div className="admin-panel-container">
          {activeChild || <div>Panel not found</div>}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
